import Vue from 'vue';

import VueProgressBar from 'vue-progressbar';
import VueObserveVisibility from 'vue-observe-visibility';
import VueYoutube from 'vue-youtube';
import 'intersection-observer';

import App from './App.vue';
import router from './router';
import store from './store';

/* UNCOMMENT TO ENABLE CACHE import './registerServiceWorker'; */
/* UNCOMMENT TO ENABLE i18n import i18n from './i18n'; */

import meta from './assets/data/meta.json';
import clientAnalyticsPlugin from '@/plugins/analytics.client';

Vue.config.productionTip = false;


Vue.use(VueProgressBar, {
    color: meta.progressbarColor
});

Vue.use(VueObserveVisibility);

Vue.use(clientAnalyticsPlugin);

Vue.use(VueYoutube);

new Vue({
    router,
    store,
    /* UNCOMMENT TO ENABLE i18n i18n, */
    render: h => h(App)
}).$mount('#app');
